import React, { useState } from "react";
import styles from "./faqs.module.css";
import { TextComponent } from "../../components";
import HeadingComponent from "../../components/HeadingComponent/HeadingComponent";
import { FaPlus, FaMinus } from "react-icons/fa";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const faqItems = [
    {
      id: 1,
      title: "How do I add or remove staff members from my bakery ?",
      text: "Nibh quisque suscipit fermentum netus nulla cras porttitor euismod nulla. Orci, dictumst nec aliquet id ullamcorper venenatis. Fermentum sulla craspor ttitore  ismod nulla.",
    },
    {
      id: 2,
      title: "Can I assign tasks to multiple staff members at once?",
      text: "You can contact our support team via email at support@example.com or through our contact form.",
    },
    {
      id: 3,
      title: "How do I create and edit recipes in the system?",
      text: "Yes, we offer international shipping to most countries. Shipping fees may vary depending on the destination.",
    },
    {
      id: 4,
      title:
        "What happens if I need to adjust an order after it has been scheduled?",
      text: "We accept Visa, MasterCard, American Express, PayPal, and Apple Pay.",
    },
    {
      id: 5,
      title: "How do I track inventory usage linked to completed tasks?",
      text: "Yes, you can change or cancel your order within 24 hours of placing it.",
    },
  ];

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={styles.mainCont}>
      <HeaderComponent heading={"FAQ's"} headingStyle={styles.headingStyle}/>

      {faqItems.map((item, index) => (
        <div
          key={item.id}
          className={styles.listItem}
          style={{
            borderBottom:
              openIndex === index ? "2px solid var(--secondary-color)" : "none",
          }}
        >
          <div
            className={styles.question}
            onClick={() => handleToggle(index)}
            style={{
              cursor: "pointer",
              color: "var(--secondary-color)",
              fontFamily: "Urbanist-bold",
              marginBottom: "10px",
              fontSize: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#000",
              position: "relative",
            }}
          >
            <div
              style={{
                fontSize: "16px",
                fontWeight: "300",
                marginRight: "10px",
              }}
            >
              {index + 1}
            </div>
            <div style={{ fontWeight: "bold", flex: 1 }}>
              <TextComponent text={item.title} />
            </div>
            <div style={{ color: "#000", fontSize: "16px" }}>
              {openIndex === index ? <FaMinus /> : <FaPlus />}
            </div>
          </div>
          {openIndex === index && (
            <TextComponent
              text={item.text}
              style={{ fontSize: "16px", marginTop: "5px" }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default Faqs;
